import React from "react";

// Placeholder body shown while LeagueContext and DraftContext load. It exists
// so entering a league keeps the nav bar and the page background on screen
// instead of dropping to a full-screen logo, which read as the app relaunching
// every time a league was opened.
//
// Deliberately generic: the layout does not know which tab is about to render,
// so this approximates the shape every league page shares (a card stack) rather
// than mimicking one of them.
const shimmer = "leagueSkeletonShimmer";

function Bar({ width, height = 12 }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: 6,
        backgroundColor: "var(--color-border)",
        animation: `${shimmer} 1.4s ease-in-out infinite`,
      }}
    />
  );
}

function Card() {
  return (
    <div
      style={{
        backgroundColor: "var(--color-bg-card)",
        border: "1px solid var(--color-border)",
        borderRadius: 16,
        padding: 16,
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      <Bar width="45%" height={14} />
      <Bar width="80%" />
      <Bar width="65%" />
    </div>
  );
}

export default function LeagueSkeleton() {
  return (
    <div
      style={{ minHeight: "100vh", backgroundColor: "var(--color-bg-page)" }}
      aria-busy="true"
      aria-label="Loading league"
    >
      <div
        style={{
          maxWidth: 896,
          margin: "0 auto",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <Card />
        <Card />
        <Card />
      </div>
      <style>{`@keyframes ${shimmer} { 0%, 100% { opacity: 1; } 50% { opacity: 0.45; } }`}</style>
    </div>
  );
}
